// Host-agnostic Datadog RUM error tracker. Reads window.DD_RUM published by
// @datadog/browser-rum after init. No-ops if the host hasn't initialized RUM.
interface RumGlobal {
  addError(error: unknown, context?: object): void
}

function getRum(): RumGlobal | null {
  if (typeof window === 'undefined') return null
  const rum = (window as unknown as { DD_RUM?: unknown }).DD_RUM
  if (rum && typeof (rum as RumGlobal).addError === 'function') {
    return rum as RumGlobal
  }
  return null
}

export function trackError(error: unknown, context?: object) {
  getRum()?.addError(error, context)
}
